import { render, staticRenderFns } from "./ManageTransactions.vue?vue&type=template&id=14bb61f8&"
import script from "./ManageTransactions.vue?vue&type=script&lang=js&"
export * from "./ManageTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports